export default __webpack_public_path__ + "static/media/Herzenslust.f6e73454.MP4";